import { render, staticRenderFns } from "./KiraArtisHesaplayici.vue?vue&type=template&id=07a87e56"
import script from "./KiraArtisHesaplayici.vue?vue&type=script&lang=ts"
export * from "./KiraArtisHesaplayici.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports